import API from "../API";

export default class Translate extends API {
  constructor() {
    super('translate')
  }
 
}
